import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "primereact/resources/themes/saga-blue/theme.css"; // PrimeReact theme
import "primereact/resources/primereact.min.css"; // PrimeReact CSS
import './App.css';
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import AppProvider from "./utils/AppProvider";
import { PrimeReactProvider } from "primereact/api";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import { store } from "./store";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import ChatBot from 'react-simple-chatbot';
import { ThemeProvider } from 'styled-components';
import chatbotService from "./services/chatbot-service";

Sentry.init({
  dsn: "https://9f29a2e0fadd5b36db85ff100232094e@o4507922114805760.ingest.de.sentry.io/4507922122080336",
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 0.1,
  environment: "production",
});

const theme = {
  background: '#f5f8fb',
  fontFamily: 'Helvetica Neue, Arial, sans-serif',
  headerBgColor: '#DD0A37',    
  headerFontColor: '#fff', 
  headerFontSize: '16px',
  botBubbleColor: '#DD0A37',   
  botFontColor: '#fff',
  userBubbleColor: '#fff',
  userFontColor: '#4a4a4a',
};


const ChatbotAPI = (props) => {
  const { steps, triggerNextStep } = props;
  const [result, setResult] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  
  // Cette "ref" survit aux re-renders et ne change jamais
  const hasCalledAPI = React.useRef(false);

  React.useEffect(() => {
    // Si on a déjà lancé l'appel, on sort immédiatement
    if (hasCalledAPI.current) return;
    
    hasCalledAPI.current = true;
    const question = steps.userQuestion.value;

    chatbotService.post({ question })
      .then((res) => {
        setResult(res.data.response);
        setLoading(false);
        // On attend un petit délai avant de redonner la main à l'utilisateur
        setTimeout(() => triggerNextStep(), 500);
      })
      .catch((err) => {
        setResult("Désolé, une erreur est survenue.");
        setLoading(false);
        setTimeout(() => triggerNextStep(), 500);
      });
  }, []); // [] signifie : s'exécute uniquement au montage initial

  return (
    <div>
      {loading ? "Atlas réfléchit..." : result}
    </div>
  );
};



const steps = [
  {
    id: "welcome",
    message: "Bienvenue dans l’Atlas Gexpertise ! Posez votre question 👇",
    trigger: "userQuestion",
  },
  {
    id: "userQuestion",
    user: true,
    trigger: "botResponse",
  },
  {
    id: "botResponse",
    component: <ChatbotAPI />, // Gardez ceci mais assurez-vous de waitAction
    asMessage: true,
    waitAction: true, // IMPORTANT : empêche le chatbot de boucler tout seul
    trigger: "userQuestion",
  },
];


const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
      <AppProvider>
        <PrimeReactProvider>
          <Provider store={store}>
            <App />
   
            <ThemeProvider theme={theme}>
            <ChatBot
              headerTitle="Atlas ChatBot AI"
              steps={steps}
              floating={true} 
              opened={false}
              width="450px" 
              height="600px"
            />
          </ThemeProvider>
         
       

          </Provider>
        </PrimeReactProvider>
        </AppProvider>
      </QueryClientProvider>
    </BrowserRouter>
    <ToastContainer />
 </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
